<template>
    <div class="step-test-whatsapp-cloud col-12">
        <div class="field mt-4" v-if="templates && templates.length">
            <label>{{ t('settings-connections-steps-select_template') }}:</label>
            <select class="form-control" v-model="selectedTemplateId">
                <option disabled :value="null">{{ t('settings-connections-steps-select_template') }}</option>
                <option
                    v-for="template in templates"
                    :value="template.id"
                    :key="template.id"
                >
                    {{ template.name }} - ({{ statusTranslate(template.status) }})
                </option>
            </select>
        </div>

        <div class="field mt-4 text-xs text-muted" v-else>
            {{ t('settings-connections-steps-no_template_available') }}
        </div>

        <div class="field wpp-cloud-components" v-if="activeTemplate">
            <div v-for="(component, index) in activeTemplate.components" :key="index">
                <div v-if="component.type === 'HEADER'" :key="component.type">
                    <div>
                        <strong>{{ t('settings-connections-steps-header') }}:</strong>
                    </div>
                    <div v-if="component.format === 'TEXT'" class="text-example">
                        <strong>{{ component.text }}</strong>
                    </div>
                    <div
                        v-if="
                            component.example &&
                            component.example['header_handle'] &&
                            component.example['header_handle'].length > 0 &&
                            wppCloudMediaHeaderFormats.includes(component.format)
                        "
                    >
                        <div v-for="(variable, idx) in component.example['header_handle']" :key="idx">
                            <div class="url-input-section">
                                <strong>{{ idx + 1 }} — {{ stepTestHeaderMediaUrlLabel(component.format) }}:</strong>
                                <input
                                    type="text"
                                    class="form-control"
                                    :placeholder="variable"
                                    v-model="templateParams.header_handle[idx]"
                                />
                            </div>
                        </div>
                        <div v-if="component.format === 'DOCUMENT'" class="url-input-section mt-2">
                            <strong>{{ t('settings-connections-steps-document_filename') }}</strong>
                            <input
                                type="text"
                                class="form-control"
                                v-model="templateParams.document_filename"
                                :placeholder="t('settings-connections-steps-document_filename_placeholder')"
                            />
                        </div>
                    </div>
                    <div
                        v-if="component.format === 'LOCATION'"
                        class="url-input-section mt-2"
                    >
                        <strong>{{ t('settings-connections-steps-location_header') }}</strong>
                        <div class="mt-2">
                            <label class="small text-muted mb-0 d-block">{{ t('settings-connections-steps-location_latitude') }}</label>
                            <input type="text" class="form-control mb-2" v-model="templateParams.location_latitude" />
                            <label class="small text-muted mb-0 d-block">{{ t('settings-connections-steps-location_longitude') }}</label>
                            <input type="text" class="form-control mb-2" v-model="templateParams.location_longitude" />
                            <label class="small text-muted mb-0 d-block">{{ t('settings-connections-steps-location_name') }}</label>
                            <input type="text" class="form-control mb-2" v-model="templateParams.location_name" />
                            <label class="small text-muted mb-0 d-block">{{ t('settings-connections-steps-location_address') }}</label>
                            <input type="text" class="form-control" v-model="templateParams.location_address" />
                        </div>
                    </div>
                    <div
                        v-if="
                            component.example &&
                            component.example['header_text'] &&
                            component.example['header_text'].length > 0
                        "
                    >
                        <div v-for="(variable, idx) in component.example['header_text']" :key="idx">
                            <strong>{{ idx + 1 }}:</strong>
                            <input
                                type="text"
                                class="form-control"
                                :placeholder="variable"
                                v-model="templateParams.header_text[idx]"
                            />
                        </div>
                    </div>
                </div>

                <div v-if="component.type === 'BUTTONS'" :key="component.type">
                    <div v-for="(button, idxButton) in component.buttons" :key="'btn-' + idxButton">
                        <div v-show="button.example && button.type === 'URL'">
                            <strong>{{ t('settings-connections-steps-button') }} ({{ button.text }}):</strong>
                            <div v-if="button.example && button.type === 'URL'">
                                <strong>{{ '1' }}:</strong>
                                <input
                                    type="text"
                                    class="form-control"
                                    :placeholder="button.example[0]"
                                    v-model="templateParams.buttons[idxButton]"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="component.type === 'BODY'" :key="component.type">
                    <div>
                        <strong>{{ t('settings-connections-steps-body') }}:</strong>
                    </div>
                    <div class="text-example">{{ component.text }}</div>
                    <div
                        v-if="
                            component.example &&
                            component.example['body_text'] &&
                            component.example['body_text'].length > 0 &&
                            component.example['body_text'][0] &&
                            component.example['body_text'][0].length > 0
                        "
                    >
                        <div v-for="(variable, idxBody) in component.example['body_text'][0]" :key="idxBody">
                            <strong>{{ idxBody + 1 }}:</strong>
                            <input
                                type="text"
                                class="form-control"
                                :placeholder="variable"
                                v-model="templateParams.body_text[idxBody]"
                            />
                        </div>
                    </div>
                    <div
                        v-if="
                            component.example &&
                            component.example['body_handle'] &&
                            component.example['body_handle'].length > 0
                        "
                    >
                        <div v-for="(param, idxHandle) in component.example['body_handle']" :key="'body_handle_' + idxHandle">
                            <strong>{{ param.param_name }}:</strong>
                            <input
                                type="text"
                                class="form-control"
                                :placeholder="param.example"
                                :value="getBodyHandleValue(param.param_name)"
                                @input="updateBodyHandle(param.param_name, $event.target.value)"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group field required mt-4">
            <label :for="phoneInputId">{{ t('settings-connections-steps-enter_mobile_number') }}</label>
            <input
                :id="phoneInputId"
                :placeholder="'(##) #####-####'"
                v-mask="'(##) #####-####'"
                type="tel"
                class="form-control"
                v-model="testPhone"
                required
            />
        </div>

        <div class="action-buttons mt-4">
            <button class="btn btn-secondary" @click="$emit('back')">{{ t('settings-connections-steps-back') }}</button>
            <button class="btn btn-success" @click="emitTest" :disabled="!canTest || testing">
                <Icon icon-class="ui-send-01" size="4" />
                <span v-if="!testing">{{ t('settings-connections-steps-send_test') }}</span>
                <span v-if="testing">{{ t('settings-connections-steps-sending_test') }}</span>
            </button>
        </div>
    </div>
</template>

<script>
function safeParseJson(value) {
    if (!value) return null;
    try {
        return typeof value === 'string' ? JSON.parse(value) : value;
    } catch (e) {
        return null;
    }
}

export default {
    name: 'StepTestWhatsappCloud',
    props: {
        templates: {
            type: Array,
            default: () => [],
        },
        testing: {
            type: Boolean,
            default: false,
        },
        phoneInputId: {
            type: String,
            default: 'test-whatsapp-cloud',
        },
        /**
         * Optional: previously saved options to prefill selection/params.
         * Can be object or JSON string: { template_id, params }
         */
        initialOptions: {
            type: [Object, String],
            default: null,
        },
    },
    data() {
        const parsed = safeParseJson(this.initialOptions) || {};
        return {
            selectedTemplateId: parsed.template_id ?? null,
            testPhone: null,
            templateParams: {
                header_text: parsed.params?.header_text || [],
                header_handle: parsed.params?.header_handle || [],
                body_text: parsed.params?.body_text || [],
                body_handle: parsed.params?.body_handle || [],
                buttons: parsed.params?.buttons || [],
                document_filename: parsed.params?.document_filename ?? '',
                location_latitude: parsed.params?.location_latitude ?? '',
                location_longitude: parsed.params?.location_longitude ?? '',
                location_name: parsed.params?.location_name ?? '',
                location_address: parsed.params?.location_address ?? '',
            },
        };
    },
    computed: {
        activeTemplate() {
            if (!this.selectedTemplateId) return null;
            return this.templates.find((t) => t.id === this.selectedTemplateId) ?? null;
        },
        canTest() {
            return !!this.testPhone && !!this.selectedTemplateId;
        },
        wppCloudMediaHeaderFormats() {
            return ['IMAGE', 'VIDEO', 'GIF', 'DOCUMENT'];
        },
    },
    methods: {
        stepTestHeaderMediaUrlLabel(format) {
            if (format === 'VIDEO') return this.t('settings-connections-steps-header_media_url_video');
            if (format === 'DOCUMENT') return this.t('settings-connections-steps-header_media_url_document');
            if (format === 'GIF') return this.t('settings-connections-steps-header_media_url_gif');
            return this.t('settings-connections-steps-image_url');
        },
        statusTranslate(status) {
            if (status === 'APPROVED') return this.t('settings-connections-steps-approved');
            if (status === 'REJECTED') return this.t('settings-connections-steps-rejected');
            if (status === 'PENDING') return this.t('settings-connections-steps-pending');
            return status;
        },
        getBodyHandleValue(paramName) {
            const bodyHandleArray = this.templateParams.body_handle || [];
            const foundParam = bodyHandleArray.find((param) => param.param_name === paramName);
            return foundParam ? foundParam.value : '';
        },
        updateBodyHandle(paramName, value) {
            const bodyHandleArray = [...(this.templateParams.body_handle || [])];
            const existingIndex = bodyHandleArray.findIndex((param) => param.param_name === paramName);

            if (existingIndex !== -1) {
                bodyHandleArray[existingIndex] = { param_name: paramName, value };
            } else {
                bodyHandleArray.push({ param_name: paramName, value });
            }

            this.$set(this.templateParams, 'body_handle', bodyHandleArray);
        },
        emitTest() {
            this.$emit('test', {
                phone: this.testPhone,
                selectedTemplateId: this.selectedTemplateId,
                templateName: this.activeTemplate?.name || null,
                templateParams: JSON.parse(JSON.stringify(this.templateParams)),
            });
        },
    },
    watch: {
        selectedTemplateId(newId, oldId) {
            if (!newId || newId === oldId) return;
            // Reset params on template change (same behavior as old whatsapp-cloud.vue)
            this.templateParams = {
                header_text: [],
                header_handle: [],
                body_text: [],
                body_handle: [],
                buttons: [],
                document_filename: '',
                location_latitude: '',
                location_longitude: '',
                location_name: '',
                location_address: '',
            };
        },
        initialOptions: {
            handler(newVal) {
                const parsed = safeParseJson(newVal) || {};
                if (parsed.template_id) this.selectedTemplateId = parsed.template_id;
                if (parsed.params) {
                    this.templateParams = {
                        header_text: parsed.params?.header_text || [],
                        header_handle: parsed.params?.header_handle || [],
                        body_text: parsed.params?.body_text || [],
                        body_handle: parsed.params?.body_handle || [],
                        buttons: parsed.params?.buttons || [],
                        document_filename: parsed.params?.document_filename ?? '',
                        location_latitude: parsed.params?.location_latitude ?? '',
                        location_longitude: parsed.params?.location_longitude ?? '',
                        location_name: parsed.params?.location_name ?? '',
                        location_address: parsed.params?.location_address ?? '',
                    };
                }
            },
            deep: false,
        },
    },
};
</script>

<style scoped lang="less">
.step-test-whatsapp-cloud {
    .action-buttons {
        display: flex;
        gap: 12px;
        justify-content: stretch;
        
        button {
            flex: 1;
            justify-content: center;
        }
    }

    .wpp-cloud-components {
        display: flex;
        flex-direction: column;
        margin-top: 20px;

        input {
            display: inline-block;
            width: 400px;
            max-width: 80%;
        }

        .text-example {
            padding: 15px;
            border-radius: 10px;
            background: #f5f5f5;
            display: inline-block;
            width: 416px;
            max-width: 80%;
            font-size: 14px;
            white-space: pre-wrap;
            strong {
                font-weight: 500;
                font-size: 16px;
            }
        }

        .url-input-section {
            margin-top: 15px;
            padding: 15px;
            background: #f9f9f9;
            border-radius: 8px;
            border: 1px solid #e0e0e0;

            strong {
                display: block;
                margin-bottom: 8px;
                color: #333;
            }

            input {
                width: 100%;
                max-width: none;
            }
        }
    }
}
</style>


